<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-04-25 14:18:05
 * @Description: 设备台账表单
 * @LastEditors: Please set LastEditors
-->
<template>
  <el-form
    class="h-100 w-100 p-r-20"
    :model="fromData"
    ref="form"
    label-width="100px"
    :inline="false"
    size="normal"
  >
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="资产编号">
          <el-input size="mini" v-model="fromData.AssetNumber"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="资产名称">
          <el-input size="mini" v-model="fromData.AssetName"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="资产组编号">
          <el-input size="mini" v-model="fromData.AssetGroupName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="资产组">
          <el-input size="mini" v-model="fromData.AssetGroup"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="KKS编码">
          <el-input size="mini" v-model="fromData.KKSNumber"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="所属组织">
          <el-input size="mini" v-model="fromData.organization"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="设备专业">
          <el-input size="mini" v-model="fromData.equipmentProfessional"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="所属部门">
          <el-input size="mini" v-model="fromData.department"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="资产类别">
          <el-input size="mini" v-model="fromData.AssetClass"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="类别描述">
          <el-input size="mini" v-model="fromData.typeDescription"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="重要性">
          <el-input size="mini" v-model="fromData.importance"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="规格型号">
          <el-input size="mini" v-model="fromData.modelsSpecifications"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="投运日期">
          <el-input size="mini" v-model="fromData.shipmentDate"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="制造商">
          <el-input size="mini" v-model="fromData.producers"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="出厂日期">
          <el-input size="mini" v-model="fromData.factoryDate"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="出厂编号">
          <el-input size="mini" v-model="fromData.factoryNumber"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="安装单位">
          <el-input size="mini" v-model="fromData.installationUnit"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="外部设备">
          <el-input size="mini" v-model="fromData.externalDevices"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="密封点(静)">
          <el-input size="mini" v-model="fromData.sealingPointsByQuiet"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="密封点(动)">
          <el-input size="mini" v-model="fromData.sealingPointsByMove"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="质保期">
          <el-input size="mini" v-model="fromData.warrantyPeriod"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="设备评级">
          <el-input size="mini" v-model="fromData.deviceLevel"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :offset="0">
        <el-form-item label="是否投运">
          <el-input size="mini" v-model="fromData.whetherPut"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" :offset="0">
        <el-form-item label="设备状态">
          <el-input size="mini" v-model="fromData.deviceStatus"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      fromData: {
        AssetNumber: '5200033010602000009',
        AssetName: '1号机组A循环水泵',
        AssetGroupNumber: 'AG025',
        AssetGroup: ' 轴流泵',
        KKSNumber: '10PAC11AP001',
        organization: ' 115',
        equipmentProfessional: '化学',
        department: ' 设备部',
        AssetClass: '01.06.02',
        typeDescription: '',
        importance: '二类',
        modelsSpecifications: '1400HLBK-23.1',
        shipmentDate: '1970/1/1 0:00:00',
        producers: '利欧集团湖南泵业有限公司',
        factoryDate: '1970/1/1 0:00:00',
        factoryNumber: '',
        installationUnit: '',
        externalDevices: '',
        sealingPointsByQuiet: '',
        sealingPointsByMove: '',
        warrantyPeriod: '',
        deviceLevel: '',
        whetherPut: '',
        deviceStatus: '在用',
      },
    }
  },
}
</script>
